export default "__VITE_ASSET__RhGsBeG4__"